import { last } from 'ramda';

const round = roundWith => value => Math.ceil(value / roundWith) * roundWith;

const roundBy = roundWith => (value) => {
  const result = round(roundWith)(value);
  return result === value ? result + roundWith : result;
};

const roundBy5 = roundBy(500);
const roundBy10 = value => roundBy(1000)(roundBy5(value));
const roundBy50 = value => roundBy(5000)(roundBy10(value));

const roundOptions = [
  100, 200, 500, 1000,
  2000, 5000, 7000, 10000,
  12000, 15000, 20000,
];

const dollarRound = round(100);
// eslint-disable-next-line import/prefer-default-export
export const cashOptions = (total) => {
  if (!Number.isFinite(total)) return [];

  const numberOfOptions = 3;
  let options = roundOptions.reduce((acc, option) => {
    if (acc.length > numberOfOptions - 1) return acc;
    if (option > total && !acc.includes(option)) return [...acc, option];
    return acc;
  }, [dollarRound(total)]);

  if (options.length < numberOfOptions) {
    const result = Array(numberOfOptions - options.length).fill().map(
      (option, idx) => roundBy50(last(options)) + (5000 * idx)
    );
    options = options.concat(result);
  }

  return [
    ...options,
  ];
};
